import React from "react";
import { Box, Grid } from "@mui/material";
import MemoryIcon from '@mui/icons-material/Memory';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import slide1 from "../../assets/images/site/semiconductors.jpeg";
import slide2 from "../../assets/images/site/aboutus.jpg";
import slide3 from "../../assets/images/site/vlsi-experience.jpg";
import slide4 from "../../assets/images/site/deliverables.jpg";
import customLayout from "../../assets/images/site/customlayout.png";
import asicfpga from "../../assets/images/site/asic_and_fpga.png";
import design from "../../assets/images/site/design.png";

import "./PhyelementsMain.css";
import HomeSlider from "./HomeSlider";
import PhyelementsMain from "./PhyelementsMain";
import SiteFooter from "../OurServices/ASIC/SiteFooter";
import { useNavigate } from "react-router-dom";

export default function HomePage() {
  const navigate = useNavigate();
  return (
    <>
      <PhyelementsMain />
      <Box className="swiper-container">
        <Swiper
          direction={"vertical"}
          slidesPerView={1}
          spaceBetween={10}
          mousewheel={true}
          pagination={{
            clickable: true,
          }}
          modules={[Mousewheel, Pagination, Autoplay]}
          speed={2000}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <HomeSlider
              title={"Precision-driven layout design for Memory, eNVM, Analog, IO, and Standard Cells powering next-gen chips"}
              description={ "Specialists in VLSI services, focused on high-performance, low-power design for ASICs and SoCs." }
              imgPath={slide1}
            />
          </SwiperSlide>
          <SwiperSlide>
            <HomeSlider
              title={"About Us"}
              description={ "Established in 2019, our expertise lies in providing VLSI design services and development across various technology nodes." }
              imgPath={slide2}
            />
          </SwiperSlide>
          <SwiperSlide>
            <HomeSlider
              title={"Experience"}
              description={ "Decades of expertise in high speed and high dense SRAM, ROM, eNVM, SerDes IP design, supporting semiconductor companies from specification to GDSII with optimized Power, Performance, Area and manufacturability." }
              imgPath={slide3}
            />
          </SwiperSlide>
          <SwiperSlide>
            <HomeSlider
              title={"Deliverables"}
              description={ "We closely work with our clients to deliver IP design that meets strict foundry and design rules." }
              imgPath={slide4}
            />
          </SwiperSlide>
        </Swiper>
      </Box>      
      <Box sx={{ width: "100%", marginTop:"10px"}}>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ paddingTop: "1em" }}
      >
        {/* <Grid item xs={0.5} sm={0.5}></Grid> */}
        <Grid item xs={12} sm={4}>
          <Box className="info-box main-heading">Comprehensive Semiconductor Design Services</Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box className="info-box" onClick={() => {navigate('/services/designlayout'); window.scrollTo(0, 0);}}>
            <img src={asicfpga} width="80px" height="80px"></img>
           <span>Design & layout capabilities</span>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box className="info-box" onClick={() => {navigate('/services/physicaldesign'); window.scrollTo(0, 0);}}>
            <img src={customLayout} width="80px" height="80px"></img>
            <span>Physical design & verification</span></Box>
        </Grid>
        {/* <Grid item xs={0.5} sm={0.5}></Grid> */}
      </Grid>
    </Box>
    <SiteFooter/>
    </>
  );
}

